import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';
import Swal from 'sweetalert2';

export default class SLSItemsClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
    this.notify = new Notifier();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/items', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getItemDescribe() {
    try {
      const { data } = await this.api.get('/items/describe');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async getItemById(id) {
    try {
      return await this.api.get(`/items/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async createItem(item) {
    try {
      const response = await this.api.post('/items', item);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar Produto';
      throw new Error(errorMessage);
    }
  }

  async updateItem(id, data) {
    try {
      const response = await this.api.put(`/items/${id}`, data);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar Produto';
      throw new Error(errorMessage);
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/items/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o Produto');
    }
  }

  async getInfoItemByCodCategEndCodMarca(dataFind) {
    try {
      console.log('CHAMANDO ROTA PRA BUSCAR DETALHES ITEM');
      const {
        codMarca, codCateg, tabelaprecoId, familiaComercialId,
      } = dataFind;
      const response = await this.api.get(`/items/infoItem/marca/${codMarca}/categ/${codCateg}?tabelaprecoId=${tabelaprecoId}&familiaComercialId=${familiaComercialId}`);
      console.log('CHAMOU ROTA PRA BUSCAR DETALHES ITEM', response.data);
      if (!response.data) {
        await Swal.fire({
          title: 'Atenção',
          text: 'Não foi encontrado este item na Tabela Preço Item. Entre em contato com o ADM Vendas, ou tente digitar o produto em Pedidos de Venda',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('ERRO AO BUSCAR DETALHES DO ITEM:', error.response.data);

        return error.response.data;
      } if (error.request) {
        console.error('Nenhuma resposta do servidor:', error.request);
      } else {
        console.error('Erro ao configurar a requisição:', error.message);
      }
      return {
        success: false,
        title: 'Erro inesperado',
        message: 'Ocorreu um erro ao tentar buscar os detalhes do item. Por favor, tente novamente mais tarde.',
      };
    }
  }

  async detalhesPedidoStored(familiaComercialId, precoId, codMarca, codCateg) {
    try {
      const response = await this.api.get(
        `/items/detalhesItem/${familiaComercialId}/${precoId}/${codMarca}/${codCateg}`,
      );

      if (!response.data) {
        return {
          success: false,
          message: 'Nenhum dado encontrado',
        };
      }

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Erro em detalhesPedidoStored:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  }
}
